import DOMPurify from "dompurify";

/**
 * v-safe-html directive - sanitizes HTML to prevent XSS attacks
 * Use this instead of v-html for any user-generated or external content
 *
 * Usage: <div v-safe-html="htmlContent"></div>
 */
export const vSafeHtml = {
  mounted(el, binding) {
    el.innerHTML = DOMPurify.sanitize(binding.value || "");
  },
  updated(el, binding) {
    el.innerHTML = DOMPurify.sanitize(binding.value || "");
  },
};
